import React, {memo, useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import isEqual from 'lodash/isEqual';

import {Marker} from '..';

const MarkersComponent = ({markers}) => {
  const [activeMarker, setActiveMarker] = useState(null);

  useEffect(() => {
    if (!markers.find(item => item.id === activeMarker)) {
      setActiveMarker(null);
    }
  }, [markers, activeMarker]);

  return (
    <>
      {markers.map(item => (
        <Marker
          key={item.id}
          active={item.id === activeMarker}
          setActiveMarker={setActiveMarker}
          {...item}
        />
      ))}
    </>
  );
};

MarkersComponent.propTypes = {
  markers: PropTypes.array.isRequired,
};

/**
 * The compare function for this component aka shouldComponentUpdate.
 *
 * @param {object} prevProps - pre-property
 * @param {object} nextProps - the props object that the component will receive
 *
 * @returns {boolean}
 *   Controls whether components are updated true update false does not update
 */
function areEqual(prevProps, nextProps) {
  if (isEqual(prevProps.markers, nextProps.markers)) return true;
  return false;
}

export const Markers = memo(MarkersComponent, areEqual);

// @todo: find a way to not duplicate the props definition.
Markers.propTypes = {
  markers: PropTypes.array.isRequired,
};
